@if(navService.todayScheduledCallbacks.isConnectHubScreen){
@if(navService.todayScheduledCallbacks.scheduledCallCount){
<div class="call-banner" style="right: 15px;">
  <div class="call-banner__left">
    <div class="call-banner__group">
      <div class="call-banner__icon">
        <i class="fa-solid fa-phone"></i>
      </div>
      <div class="call-banner__content">
        <span class="label">Today Scheduled Calls</span>
      </div>
      <div class="call-banner__count">
        <span class="counter">{{navService.todayScheduledCallbacks.scheduledCallCount}}</span>
      </div>
    </div>
    <div class="call-banner__divider"></div>
    <div class="call-banner__group" *ngIf="callBannerState.displayText">
      <div class="call-banner__icon">
        <i class="fa-regular fa-clock"></i>
      </div>
      <div class="call-banner__content">
        <span class="label" [attr.data-tooltip]="callBannerState.tooltipText" data-tooltip-conf="bottom multiline">
          {{callBannerState.displayText}}
          <i style="cursor: pointer" class="fa-light fa-copy"
            (click)="copyToClipboard(callBannerState.currentCallId)"></i>
        </span>
        @if(callBannerState.waitTimeMins){
        <div class="call-banner__divider"></div>
        <span class="value">
          <strong>{{callBannerState.waitTimeMins}}</strong> Mins
        </span>
        }
      </div>
    </div>
  </div>
  <div class="call-banner__actions">
    <!-- <a class="button" [ngClass]="{ 'disabled': !callBannerState.activeDueCall }"
       href="javascript:void(0);" (click)="onCallbackDial()">
      Call Back
    </a> -->
    <a class="button btn-outline" [routerLink]="'/agent/summaries/callback'">
      View All
    </a>
    <!-- <div style="cursor: pointer" (click)="abc()" data-tooltip="Refresh Data" data-tooltip-conf="bottom"
      class="call-banner__icon">
      <i class="fa-solid fa-arrows-rotate"></i>
    </div> -->
  </div>
</div>
}
}